<template>
  <div class="container pb-5 mt-5">
    <nav aria-label="breadcrumb ">
      <ol class="mt-4">
        <li class="breadcrumb-item">
          <a href="/"> &lt; &nbsp; {{ $t('Support.BackLink') }}</a>
        </li>
      </ol>
    </nav>
    <h1 class="text-uppercase mt-5 mb-3 d-none">
      {{ $t('Upload.UplaodTitle') }}
    </h1>
    <p class="d-none">{{ $t('Upload.UplaodDesc') }}</p>
    <div class="mb-5">
      <section class="wrapper">
        <component
          :is="WidgetComponent"
          :campaign-id="$t('CampaignID')"
         :referral-source="referralSource"
        ></component>
      </section>
    </div>
  </div>
</template>

<script>
import CampaignWidgets from '../Home/Homepagecomponents/CampaignWidgets.vue';

export default {
  components: { CampaignWidgets },
  props: {

  },
  data() {
    return {
      showComponent: false,
      WidgetComponent: CampaignWidgets,
    };
  },
  computed: {
    referralSource() {
      return this.$route.path.toLowerCase() === '/amoe' ? 'amoe' : 'standard';
    },
  },
};
</script>
